<div>
    <ion-grid>
        <ion-row class="ion-justify-content-center">
            <ion-col
                size="12"
                size-xs="12"
                size-sm="12"
                size-md="10"
                size-lg="8"
                size-xl="6"
            >
                <form [formGroup]="travelForm" (ngSubmit)="submit()">
                    <ion-card>
                        <ion-card-header>
                            <ion-card-title color="teal" class="section-title">
                                {{
                                    content?.user?.pages?.profile?.passport
                                        ?.cardtitle
                                }}</ion-card-title
                            >
                        </ion-card-header>
                        <ion-card-content>
                            <ion-list>
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{
                                            content?.user?.pages?.profile
                                                ?.passport?.psnumber
                                        }}</ion-label
                                    >
                                    <ion-input
                                        type="text"
                                        formControlName="passportnumber"
                                    ></ion-input>
                                </ion-item>
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{
                                            content?.user?.pages?.profile
                                                ?.passport?.psissue
                                        }}</ion-label
                                    >
                                    <ion-select
                                        cancelText="Dismiss"
                                        okText="Ok"
                                        formControlName="passportissuecountry"
                                    >
                                        <ion-select-option
                                            *ngFor="
                                                let country of content?.countries;
                                                let i = index;
                                                trackBy: trackByIndex
                                            "
                                            value="{{ country }}"
                                        >
                                            {{ country }}</ion-select-option
                                        >
                                    </ion-select>
                                </ion-item>
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{
                                            content?.user?.pages?.profile
                                                ?.passport?.psdate
                                        }}</ion-label
                                    >
                                    <div class="date-picker-box">
                                        <input
                                            class="date-picker-custom-input"
                                            matInput
                                            [matDatepicker]="
                                                pickerPassportIssue
                                            "
                                            [max]="maxIssueDate"
                                            placeholder="MM/DD/YYYY"
                                            formControlName="passportissuedate"
                                        />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="pickerPassportIssue"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #pickerPassportIssue
                                        ></mat-datepicker>
                                    </div>
                                </ion-item>
                                <ion-item>
                                    <ion-label position="stacked">
                                        {{
                                            content?.user?.pages?.profile
                                                ?.passport?.psexpiration
                                        }}</ion-label
                                    >
                                    <div class="date-picker-box">
                                        <input
                                            class="date-picker-custom-input"
                                            matInput
                                            [matDatepicker]="
                                                pickerPassportExpired
                                            "
                                            placeholder="MM/DD/YYYY"
                                            formControlName="passportexpiredate"
                                            [min]="minDate"
                                            [max]="maxExpirationDate"
                                        />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="pickerPassportExpired"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #pickerPassportExpired
                                        ></mat-datepicker>
                                    </div>
                                </ion-item>
                            </ion-list>
                        </ion-card-content>
                        <ion-card-content>
                            <div class="ion-text-center">
                                <ion-button type="submit" size="large"
                                    >Update</ion-button
                                >
                            </div>
                        </ion-card-content>
                    </ion-card>
                </form>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>
